import { render } from "./SearchGroup.vue?vue&type=template&id=5d476842"
import script from "./SearchGroup.vue?vue&type=script&lang=js"
export * from "./SearchGroup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__